import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Icon from 'components/shared/Icon'
import TicketTypeRadioDots from './components/TicketTypeRadioDots'
import { useMemo } from 'react'
import { DefaultTheme } from 'styled-components'
import { useResolutions } from 'store/resolutions'
import { TicketInfo } from 'store/api-slice/types'
import { Color } from 'styles/types'
import { Decor, Description, Wrapper } from './styles'

interface TicketTypeRadioInfoStubProps {
    isChecked: boolean
    info: TicketInfo[]
    isPromotionActive?: boolean
    theme?: DefaultTheme
}

const TicketTypeRadioInfoStub = ({
    isChecked,
    info,
    isPromotionActive,
    theme,
}: TicketTypeRadioInfoStubProps) => {
    const { isTablet } = useResolutions()

    const hasDarkMode = theme?.mode === 'dark'

    const contentColor = useMemo((): { icon: Color; title: Color } => {
        if (hasDarkMode)
            return { icon: 'grayscale_200', title: 'grayscale_200' }
        if (isPromotionActive !== undefined) {
            if (!isPromotionActive)
                return { icon: 'grayscale_500', title: 'grayscale_900' }
        }
        return { icon: 'secondary_500', title: 'grayscale_900' }
    }, [hasDarkMode, isPromotionActive])

    return (
        <Wrapper direction="row" mt={[12, 36]} pt={[36, 48]} isFullWidth>
            <Decor>
                <TicketTypeRadioDots isChecked={isChecked} theme={theme} />
            </Decor>
            <Box gap={24}>
                {info.map((item, index) => {
                    const { description, descriptionItems, title, iconName } =
                        item

                    return (
                        <Box direction="row" gap={[10, 16]} key={index}>
                            <Icon
                                variant={iconName ? iconName : 'palm'}
                                size={[22, 30]}
                                color={contentColor.icon}
                            />
                            <Box gap={[2, 4]}>
                                <Text
                                    variant="bodySmall"
                                    color={contentColor.title}
                                >
                                    {title}
                                </Text>
                                <Box
                                    // display regulations link...
                                    direction={
                                        (descriptionItems &&
                                            descriptionItems.length > 1) ||
                                        isTablet
                                            ? 'column' // ...under, if there is multiple advantages
                                            : 'row' // ...inline, if tehere is only shorter description
                                    }
                                >
                                    {descriptionItems && (
                                        <Text
                                            variant="bodySmall"
                                            color="grayscale_700"
                                        >
                                            {descriptionItems.map(
                                                (descriptionItem, index) => (
                                                    <span
                                                        className="description-item"
                                                        key={index}
                                                    >
                                                        {descriptionItem}
                                                    </span>
                                                )
                                            )}
                                        </Text>
                                    )}
                                    {!!description && (
                                        <Description
                                            variant="bodySmall"
                                            color="grayscale_700"
                                            mb={
                                                index === info.length - 1
                                                    ? 0
                                                    : 12
                                            }
                                            mt={2}
                                            dangerouslySetInnerHTML={{
                                                __html: description,
                                            }}
                                            onClick={(event) =>
                                                event.stopPropagation()
                                            }
                                            theme={theme}
                                            style={
                                                isPromotionActive !==
                                                    undefined &&
                                                !isPromotionActive
                                                    ? {
                                                          pointerEvents: 'auto',
                                                          cursor: 'default',
                                                      }
                                                    : {}
                                            }
                                        />
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    )
                })}
            </Box>
        </Wrapper>
    )
}

export default TicketTypeRadioInfoStub
